const TestErrorComponent = () => {
  throw new Error("Test error boundary");
  return <div>This won't render</div>;
};

export default TestErrorComponent;
